import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { getUrl } from '../_shared/utils';
import { Observable } from 'rxjs';
import { JWTTokenService } from './jwtToken.service';

@Injectable()
export class CoreEngineService {
  private serviceUrl: string;

  constructor(
    private http: HttpClient, private jwtTokenService: JWTTokenService) {
      this.serviceUrl = getUrl('coreengine');
    }

  public getCoreEngineObjects(): Observable<CoreEngineObject[]> {
    return this.http.get<CoreEngineObject[]>(`${this.serviceUrl}/objects`, this.requestOptionsAuthenticated());
  }

  public getCoreEngineObjectById(objectId: number): Observable<CoreEngineObject> {
    return this.http.get<CoreEngineObject>(`${this.serviceUrl}/objects/${objectId}`, this.requestOptionsAuthenticated());
  }

  public save(object: CoreEngineObject) {
    return this.http.post<any>(`${this.serviceUrl}/objects/save` , object, this.requestOptionsAuthenticated());
  }

  public delete(objectId: number) {
    return this.http.get<any>(`${this.serviceUrl}/objects/delete/${objectId}`, this.requestOptionsAuthenticated());
  }

  public getServiceDisplayName(): string {
    return 'Core Engine';
  }

  private requestOptionsAuthenticated() {
    const requestOptions = {
        headers: new HttpHeaders()
            .set('Content-type', 'application/json')
            .append('Authorization', 'Bearer ' + this.jwtTokenService.getToken('portal')),
    };
    return requestOptions;
}
}

export interface CoreEngineObject {
  id: number;
  name: string;
  payload: Object;
  fileDownloadUrl: string;
  triggerParameters: any; // prefetch
}

